import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { Order } from '@consumer/graphql'
import { ModalContent } from '../Common/ModalContent'
import { ICloseModalOptions } from '../InstructionsModal'
import { AddressForm, AddressInputGroupType } from './AddressForm'

export interface IAddressFormModalContentProps {
  order: Order
  closeModal: ({ clearAddressFields, clearGeocode, showToast, toastProps }: ICloseModalOptions) => void
  includeTermsAndConditions: boolean
}

export const AddressFormModalContent = ({
  order,
  closeModal,
  includeTermsAndConditions,
}: IAddressFormModalContentProps) => {
  const { t } = useTranslation()
  const { isSubmitting, isValid, touched, handleSubmit } = useFormikContext<AddressInputGroupType>()

  return (
    <ModalContent
      headerMain={'Edit Address'}
      headerSecondary={''}
      submitText={'Save Address'}
      cancelText={t('common:CANCEL')}
      onSubmit={handleSubmit}
      closeModal={closeModal}
      disabled={isSubmitting || !isValid || !touched}
      loading={isSubmitting}
      submitButtonStyles={{ width: '100%' }}
      includeTermsAndConditions={includeTermsAndConditions}
      termsAndConditionsAction={'editing my address'}
    >
      <AddressForm order={order}></AddressForm>
    </ModalContent>
  )
}
